import { useRouteLoaderData } from "@remix-run/react";
import type { loader as rootLoader } from "../../root";
import { generateFileURLBasePath, generateResizeUrl } from "~/utils/file/generateFileURL";

type stringReco = {
  width?: string | number,
  height?: string | number,
  fit?: string | number,
  crop?: string | number,
  quality?: string | number,
  dpr?: string | number,
  format?: string | number,
  f?: string | number,
  w?: string | number,
  h?: string | number,
  q?: string | number,
  fm?: string | number,
}


export const useGetThum = () => {
  const root = useRouteLoaderData<typeof rootLoader>("root");
  return (thumbnail_path: string | undefined, param: stringReco = {
    quality: 80
  }) => {
    //const url = generateFileURL(thumbnail_path ?? "", undefined, root?.basePath);
    if (root?.ENV.DB_ENV === "local") {
      return generateFileURLBasePath(
        {
          DB_ENV: root?.ENV.DB_ENV ?? "local",
          WORKER_URL: root?.ENV.WORKER_URL ?? "local",
          R2_PUBLIC_URL: root?.ENV.R2_PUBLIC_URL ?? "local",
        }
      ) + "/" + (thumbnail_path);
    }
    return generateResizeUrl(thumbnail_path ?? "", param, undefined, root?.apiURL);
    //return url;
  };
};

// resize
// http://localhost:8787/img/resize/f25f5f1a-e1e0-4c16-8916-6ca5f14d8390?width=1000